module.exports = __webpack_public_path__ + "img/arrow-hint-navigation-left.ac521f6c.png";